export default __webpack_public_path__ + "static/media/r4_sword_favonius_sword.40373817.png";